import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stone-400 disabled:pointer-events-none disabled:opacity-50';
  const variants = {
    primary: 'bg-stone-800 text-stone-50 hover:bg-stone-900 shadow-sm',
    secondary: 'text-white shadow-sm',
    outline: 'border border-stone-200 bg-transparent hover:bg-stone-100 text-stone-900',
    ghost: 'hover:bg-stone-100 text-stone-600 hover:text-stone-900'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-8 text-base',
    lg: 'h-14 px-10 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} style={variant === 'secondary' ? {
    backgroundColor: '#074e3b'
  } : undefined} {...props} data-id="element-157">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-158" />}
      {children}
    </button>;
}